module.exports = "//static.hsappstatic.net/salesImages/static-1.403/email-images/templates.png"